module.exports = __webpack_public_path__ + "img/sitedatadelete.c128091a.jpg";